import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const MobileAppComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "MobileAppPage" */ "@circle-react/components/SettingsApp/MobileApp"
    ),
);

export const MobileAppPage = () => (
  <Suspense fallback={<PageLoader />}>
    <MobileAppComponent />
  </Suspense>
);
